<template>
  <div class="workorder-process" :style="{height:height}">
    <div class="flex justify-content-space-between font-12">
      <span v-if="workorderInfo.status == 20" class="text-muted">计划开工</span>
      <span v-else>开工时间</span>

      <span v-if="workorderInfo.status == 20" class="text-blue">待开工</span>
      <span v-if="workorderInfo.status == 30" class="text-success">加工中</span>
      <span v-if="workorderInfo.status == 50" class="text-muted">已暂停</span>
      <span v-if="workorderInfo.status >= 80">已完工</span>

      <span v-if="workorderInfo.status < 80" class="text-muted">计划完工</span>
      <span v-else>完工时间</span>
    </div>
    <el-progress
      v-if="workorderInfo.status == 20"
      :percentage="5"
      :show-text="false"
      color="#409EFF"
    ></el-progress>

    <el-progress v-if="workorderInfo.status == 30" :percentage="percentage" :show-text="false"></el-progress>

    <el-progress
      v-if="workorderInfo.status == 50"
      :percentage="percentage"
      :show-text="false"
      color="#999"
    ></el-progress>

    <el-progress
      v-if="workorderInfo.status >= 80"
      :percentage="100"
      :show-text="false"
      color="#06793d"
    ></el-progress>

    <div class="flex justify-content-space-between font-12">
      <span v-if="workorderInfo.status == 20" class="text-muted">
        {{ workorderInfo.plan_starttime |
        parseTime('{y}-{m}-{d} {h}:{i}') }}
      </span>
      <span v-else>{{ workorderInfo.starttime | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>

      <span v-if="workorderInfo.status == 30" class="text-success">已用时 {{ total_used }}</span>

      <span v-if="workorderInfo.status == 50">已用时 {{ total_used }}</span>

      <span v-if="workorderInfo.status >= 80">共用时 {{ total_used }}</span>

      <span
        v-if="workorderInfo.status == 20 || workorderInfo.status == 30 || workorderInfo.status == 50"
        class="text-muted"
      >{{ workorderInfo.plan_endtime | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
      <span
        v-if="workorderInfo.status >= 80"
      >{{ workorderInfo.endtime | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
    </div>
  </div>
</template>

<script>
import { second2String } from "@/utils/common";
export default {
  name: "WorkorderProcess",
  props: {
    workorderInfo: {
      type: Object,
      default: () => {},
    },
    height: {
      type: String,
      default: "52px",
    },
  },
  computed: {
    percentage() {
      let nowtime = parseInt(new Date().getTime() / 1000);
      let percentage = 0;
      percentage =
        ((nowtime - this.workorderInfo.starttime) /
          (this.workorderInfo.plan_endtime -
            this.workorderInfo.plan_starttime)) *
          100 <
        100
          ? ((nowtime - this.workorderInfo.starttime) /
              (this.workorderInfo.plan_endtime -
                this.workorderInfo.plan_starttime)) *
            100
          : 100;
      if (
        this.workorderInfo.status == 30 ||
        (this.workorderInfo.status == 50 &&
          this.workorderInfo.percentage >= 100)
      )
        percentage = 95;
      return percentage;
    },
    total_used() {
      let nowtime = parseInt(new Date().getTime() / 1000);
      let total_used = "";
      if (
        this.workorderInfo.starttime &&
        this.workorderInfo.endtime &&
        this.workorderInfo.status >= 80
      ) {
        total_used =
          this.workorderInfo.endtime - this.workorderInfo.starttime < 60
            ? "0 min"
            : second2String(
                this.workorderInfo.endtime - this.workorderInfo.starttime,
                false,
                true
              );
      }

      if (
        (this.workorderInfo.starttime && !this.workorderInfo.endtime) ||
        (this.workorderInfo.starttime && this.workorderInfo.status < 80)
      ) {
        total_used =
          nowtime - this.workorderInfo.starttime < 60
            ? "0 min"
            : second2String(
                nowtime - this.workorderInfo.starttime,
                false,
                true
              );
      }
      return total_used;
    },
  },
};
</script>

<style lang="scss" scoped>
.workorder-process {
  height: 52px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
</style>